import { gql } from '../__generated__';

export const TEAMPERMISSIONS_USER_RESOURCES_QUERY = gql(`
  query xcpTeampermissionsUserResources($permissions: String) {
    viewer {
      id
      teamPermissions {
        userResources(
          permissions: $permissions
          resourceType: PAGES
          types: "company"
        ) {
          collection {
            permissions
            resourceId
          }
        }
      }
    }
  }
`);
